// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2l4aZ","footer":"styles_footer__2TD7n"};